import React from 'react';
import { UpgradeAccountProvider } from '../../../../contexts/settings/upgradeAccount/context';
import MainLayout from './partials/MainLayout';
import StartUpgrade from './Start';
import NextLevelRequest from './NextLevelRequest';
import { upgradeAccountScreens } from './constant';

const UpgradeAccount = () => (
  <UpgradeAccountProvider>
    <MainLayout>
      <StartUpgrade keyName={upgradeAccountScreens.START_UPGRADE} />
      <NextLevelRequest keyName={upgradeAccountScreens.UPGRADE_LEVEL} />
    </MainLayout>
  </UpgradeAccountProvider>
);

export default UpgradeAccount;
